import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogActions, DialogContent, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { SET_LINKS } from "../../Constants/reducerEvents";

export default function Links() {
  const dispatch = useDispatch();
  const [links, setLinks] = useState([]);
  const allLinks = useSelector((state) => state.links);
  const submit = () => {
    dispatch({ type: SET_LINKS, payload: links });
  };

  const addLink = () => {
    setLinks((c) => [...c, { name: "", url: "", img: "", id: uuidv4() }]);
  };
  const removeLink = (id) => {
    setLinks((c) => c.filter((c) => c.id !== id));
  };
  const updateLinkName = (id, name) => {
    setLinks(
      links.map((l) => {
        if (l.id === id) {
          return { ...l, name: name };
        }
        return l;
      })
    );
  };
  const updateLinkURL = (id, url) => {
    setLinks(
      links.map((l) => {
        if (l.id === id) {
          return { ...l, url: url };
        }
        return l;
      })
    );
  };
  const updateLinkIMG = (id, url) => {
    setLinks(
      links.map((l) => {
        if (l.id === id) {
          return { ...l, img: url };
        }
        return l;
      })
    );
  };
  const getLink = (link) => {
    return (
      <div style={{ display: "flex" }}>
        <TextField
          label="Name"
          value={link.name}
          onChange={(e) => updateLinkName(link.id, e.target.value)}
        />
        <TextField
          label="Url"
          value={link.url}
          onChange={(e) => updateLinkURL(link.id, e.target.value)}
        />
        <TextField
          label="Preferred Image (if needed)"
          value={link.img}
          onChange={(e) => updateLinkIMG(link.id, e.target.value)}
        />
        <Button color="error" onClick={() => removeLink(link.id)}>
          Delete
        </Button>
      </div>
    );
  };
  useEffect(() => {
    setLinks(allLinks);
  }, [allLinks]);

  return (
    <div>
      <div>{links.map((c) => getLink(c))}</div>
      <div style={{ display: "flex" }}>
        <Button variant="contained" onClick={addLink}>
          Add New Link
        </Button>
        <Button variant="contained" onClick={submit}>
          Save
        </Button>
      </div>
    </div>
  );
}
